import React from "react";
import Svg, { Path, Rect } from "react-native-svg";

const Statistics = () => {
  return (
    <Svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Rect
        width="56"
        height="56"
        rx="10"
        fill="rgba(255, 122, 0, 0.05)"
        fill-opacity="0.05"
      />
      <Path
        d="M33.1783 10.8641C32.9894 9.60423 32.7909 8.35387 32.602 7.09405C32.328 5.31324 32.054 3.53243 31.78 1.7611C31.6949 1.19275 31.6004 0.633882 31.506 0.0276489C28.284 1.97896 25.1094 3.91133 21.878 5.87211C22.6906 6.25101 23.437 6.60148 24.1834 6.94249C24.3251 7.0088 24.4574 7.04669 24.3062 7.26455C23.4464 8.53385 22.5299 9.75579 21.4812 10.883C20.7064 11.7166 18.8451 13.3363 18.76 13.4027C17.7963 14.1794 16.7758 14.8803 15.6987 15.5055C12.5524 17.3432 9.16986 18.4704 5.54166 18.8398C5.35269 18.8587 5.2771 18.9345 5.28655 19.1334C5.31489 19.5313 5.33379 19.9386 5.35269 20.3364C5.37158 20.9616 5.37159 20.9616 5.97628 20.99C6.32588 21.009 6.68492 21.0279 7.03451 21.0185C9.06592 20.9806 11.0879 20.8574 13.091 20.5354C15.1413 20.2038 17.1443 19.7113 19.0907 18.9819C20.7253 18.442 22.2181 17.6368 23.6354 16.6706C26.2054 14.8993 28.284 12.6543 30.0414 10.0873C30.2021 9.85051 30.3249 9.82209 30.58 9.94523C31.3642 10.3241 32.1579 10.6841 32.9516 11.044C33.0177 11.0724 33.0933 11.1672 33.1689 11.0819C33.1972 11.0346 33.1878 10.9398 33.1783 10.8641Z"
        fill="#00AB59"
        x={10}
        y={10}
      />
      <Path
        d="M0.902466 31.3217C0.902466 31.0456 1.12632 30.8217 1.40247 30.8217H6.05926V35.119H1.40247C1.12632 35.119 0.902466 34.8952 0.902466 34.619V31.3217Z"
        fill="#FFCA99"
        x={10}
        y={10}
      />
      <Path
        d="M11.2161 31.3217C11.2161 31.0456 10.9922 30.8217 10.7161 30.8217H6.05927V35.119H10.7161C10.9922 35.119 11.2161 34.8952 11.2161 34.619V31.3217Z"
        fill="#FF7A00"
        fill-opacity="0.8"
        x={10}
        y={10}
      />
      <Path
        d="M13.7944 27.8838C13.7944 27.6077 14.0183 27.3839 14.2944 27.3839H18.9512V35.119H14.2944C14.0183 35.119 13.7944 34.8952 13.7944 34.619V27.8838Z"
        fill="#FFCA99"
        x={10}
        y={10}
      />
      <Path
        d="M24.108 27.8838C24.108 27.6077 23.8842 27.3839 23.608 27.3839H18.9512V35.119H23.608C23.8842 35.119 24.108 34.8952 24.108 34.619V27.8838Z"
        fill="#FF7A00"
        fill-opacity="0.8"
        x={10}
        y={10}
      />
      <Path
        d="M26.6864 21.8676C26.6864 21.5914 26.9103 21.3676 27.1864 21.3676H31.8432V35.119H27.1864C26.9103 35.119 26.6864 34.8952 26.6864 34.619V21.8676Z"
        fill="#FFCA99"
        x={10}
        y={10}
      />
      <Path
        d="M37 21.8676C37 21.5914 36.7761 21.3676 36.5 21.3676H31.8432V35.119H36.5C36.7761 35.119 37 34.8952 37 34.619V21.8676Z"
        fill="#FF7A00"
        fill-opacity="0.8"
        x={10}
        y={10}
      />
    </Svg>
  );
};
export default Statistics;
